// **---------------------------------------------------**
// -------------------------------------------------------
// Global variables BEGIN

// store the window.scrollY value
var scrolled_y = 0;

// requestAnimationFrame
var ticking = false;

// ajax
var firstLoadDelay = 750;

// Scrollbar
var Scrollbar;

// Load GMap
var mapLoaded = false;
var hasGMap = 0;
var hasGMapScript = 0;

// LKS
var lastKnownScroll = 0;
var scrollbarState = false;

// cache some stuff
var theBody = document.getElementsByTagName("body")[0];
var theContainer = document.getElementsByClassName("barba-container")[0];
var curUrl;
var CurLang;

// screen size
var screenWidth = window.innerWidth;
var screenHeight = window.innerHeight;

// Sticky
var Stickies = new Array();
var StickyHolder;

// lightbox
var lightbox;
var lightboxItems = new Array();


// Global variables END
// **---------------------------------------------------**
// -------------------------------------------------------

// Remember
function joss(msg) {
	console.log(msg);
}

// ** This function is used only when the site FIRST load to have a custom animation (only use when ajax) ** //
function initFirstPageLoad() {
	if (theBody.classList.contains("js-firstLoad")) {
		setTimeout(function() {
			theBody.classList.remove("js-firstLoad");
		}, firstLoadDelay);
	}
}

// ** Load Google font(s) async ** //
function loadFonts() {
	var giftofspeed = document.createElement("link");
	giftofspeed.rel = "stylesheet";
	giftofspeed.href =
		"//fast.fonts.net/cssapi/911d5a2b-9a7c-416c-9dc7-4f7800135601.css";
	giftofspeed.type = "text/css";
	var godefer = document.getElementsByTagName("link")[0];
	godefer.parentNode.insertBefore(giftofspeed, godefer);

	WebFontConfig = {
		google: {
			families: ["Material+Icons"]
		}
	};

	var wf = document.createElement("script");
	wf.src = "https://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js";
	wf.type = "text/javascript";
	wf.async = "true";
	var s = document.getElementsByTagName("script")[0];
	s.parentNode.insertBefore(wf, s);
}

function loadStyles() {
	// if you need to init some variable(s) before, they go here
	// var API_nice||{};

	var l0 = document.getElementsByTagName("link")[0];
	var l1 = document.createElement("link");

	l1.rel = "stylesheet";
	l1.href = "/app/themes/Acolyte/assets/stylesheets/compiled/main.css?v=2";
	l1.charset = "UTF-8";
	l0.parentNode.insertBefore(l1, l0);

	// Swiper library
	var l2 = document.createElement("link");
	l2.rel = "stylesheet";
	l2.href = "/app/themes/Acolyte/assets/js/swiper/swiper-bundle.min.css";
	l0.parentNode.insertBefore(l2, l0);
}

function resetHasGoogleMap() {
	hasGMap = 0;
}

// ** G map ** //

function loadGoogleMap() {
	var eGmap_ele = document.querySelector(".Map");

	if (!eGmap_ele) {
		return;
	}

	if (eGmap_ele && !hasGMap && !hasGMapScript) {
		hasGMap++;
		hasGMapScript++;
		var eScriptEle = document.createElement("script");
		eScriptEle.src =
			"https://maps.googleapis.com/maps/api/js?key=" +
			eGmap_ele.getAttribute("data-api") +
			"&language=" +
			eGmap_ele.getAttribute("data-language") +
			"&callback=initMap";
		eScriptEle.type = "text/javascript";
		eScriptEle.async = "true";
		eScriptEle.setAttribute("id", "googleMap");
		var eScripts = document.getElementsByTagName("script")[0];
		eScripts.parentNode.insertBefore(eScriptEle, eScripts);

		return;
	}

	if (eGmap_ele && !hasGMap && hasGMapScript) {
		hasGMap++;
		initMap();

		return;
	}

	return false;
}

// ** Load script async ** //
function loadScript() {
	// if you need to init some variable(s) before, they go here
	// var API_nice||{};

	// Swiper library
	var s1 = document.createElement("script"),
		s0 = document.getElementsByTagName("script")[0];
	s1.async = true;
	s1.src = "/app/themes/Acolyte/assets/js/swiper/swiper-bundle.min.js";
	s0.parentNode.insertBefore(s1, s0);
}

// ** Smooth scrollbar ** //
function initScrollbar() {
	elContainer = document.getElementById("js-scroll");
	Scrollbar = window.Scrollbar;
	Scrollbar.init(elContainer);
	ScrollbarState = true;
}

function getScrollInfo(info) {
	return Scrollbar.getAll()[0].info;
}

function getCurrentScrollTop() {
	return Scrollbar.getAll()[0].scrollTop;
}

function currentlyVisible(el) {
	return Scrollbar.getAll()[0].isVisible(el);
}

function getCurrentOffset(axis) {
	if (axis == "y") {
		return Scrollbar.getAll()[0].offset.y;
	}

	return Scrollbar.getAll()[0].offset.x;
}

// ** Helpers (on va devoir éventuellement faire un .js séparé) ** //
function getCurrentNamespace() {
	return theContainer.dataset.namespace;
}

function setTheCurrentUrl() {
	curUrl = Barba.Utils.getCurrentUrl();
}

function getTheCurrentUrl() {
	setTheCurrentUrl();
	return curUrl;
}

function setTheCurrentLang() {
	if (theContainer) {
		lang = theContainer.dataset.lang;

		CurLang = lang;
	}
}

function getTheCurrentLang() {
	setTheCurrentLang();
	return CurLang;
}

function wrap(el, wrapper) {
	el.parentNode.insertBefore(wrapper, el);
	wrapper.appendChild(el);
}

function checkRedirect() {
	if (theContainer) {
		if (theContainer.dataset.redirect) {
			Barba.Pjax.goTo(theContainer.dataset.redirect);
		}
	}
}

function getParentByClassName(from, term) {
	var parent = from.parentElement;
	var search = term;

	var contains = parent.classList.contains(search) ? true : false;

	if (parent != null && !contains) {
		while (!contains) {
			parent = parent.parentElement;

			if (parent != null) {
				contains = parent.classList.contains(search) ? true : false;

				if (contains) {
					return parent;
				}
			}

			if (parent == theBody) {
				console.error(
					'Could not find a match for getParentByClassName("' +
						search +
						'"), returning <body> has a fallback'
				);
				return theBody;
			}
		}
	}

	return parent;
}

function tr(french, english) {
	_fr = arguments[0];
	_en = arguments[1];

	if (getTheCurrentLang() == "en") return _en;

	return _fr;
}

// ---------------------------
// BEGIN - YOUTUBE API

var player;
var tv;

// ** Youtube iFrame API ** //
function initYoutube() {
	if (screenWidth < 991) {
		return;
	}

	// get the tv
	tv = document.getElementById("m-youtube");

	if (tv) {
		// get video id
		var id = tv.dataset.id;

		if (id) {
			// add youtube api
			var tag = document.createElement("script");
			tag.src = "https://www.youtube.com/iframe_api";
			tag.id = "youtube_background";
			tag.async = "true";
			tag.defer = "true";
			var firstScriptTag = document.getElementsByTagName("script")[0];
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

			// init some variable
			var pDuration;
			var pCurrentTime;

			// init youtube video
			window.onYouTubeIframeAPIReady = function(e) {
				player = new YT.Player("m-youtube_screen", {
					videoId: id,
					playerVars: {
						autoplay: 0,
						controls: 0,
						showinfo: 0,
						loop: 1,
						// mute: 1,
						modestbranding: 1,
						rel: 0,
						playlist: id
					},
					events: {
						onReady: function(e) {
							videoButtonPlay();
						},
						onStateChange: function(e) {
							if (e.data === YT.PlayerState.PAUSED) {
								console.warn(
									"Browser autplay is disabled. Hiding video wrapper."
								);
								wrapper = document.getElementsByClassName(
									"hero__video__inner"
								)[0];
								wrapper.classList.remove("is-ready");
							}
						}
					}
				});
			};
		}
	}
}

function loadVideoAjax() {
	if (screenWidth < 991) {
		return;
	}
	if (tv) {
		onYouTubeIframeAPIReady();
	}
}

function videoButton() {
	var buttons = document.getElementsByClassName("js-video");

	if (buttons.length > 0) {
		for (var i = 0; i < buttons.length; i++) {
			b = buttons[i];

			b.addEventListener("click", videoButtonPlay);
		}
	}
}

function videoButtonPlay() {
	if (player != null) {
		vidRescale();
		player.playVideo();

		wrapper = document.getElementsByClassName("hero__video__inner")[0];

		wrapper.classList.add("is-ready");
	}
}

function vidRescale() {
	if (screenWidth < 991) {
		return;
	}
	if (tv) {
		if (screenWidth < 991) {
			clearYoutubePlayer();
			removeYoutubeApi();
			return;
		}

		// get the size of the tv
		w = tv.clientWidth;
		h = tv.clientHeight;

		if (tv.dataset.ref != null) {
			refID = tv.dataset.ref;
			var ref = document.getElementById(refID);

			w = ref.clientWidth;
			h = ref.clientHeight;
		}

		var screen = document.getElementById("m-youtube_screen");

		if (w / h > 16 / 9) {
			player.setSize(w, (w / 16) * 9);
			screen.style.left = "0%";
		} else {
			player.setSize((h / 9) * 16, h);
			playerWidth = screen.offsetWidth;
			screen.style.left = -((playerWidth - w) / 2) + "px";
		}
	}
}

function clearYoutubePlayer() {
	if (screenWidth < 991) {
		return;
	}

	tv = null;
	if (player) {
		player.destroy();
		player = null;
	}
}

function removeYoutubeApi() {
	if (screenWidth < 991) {
		return;
	}

	id1 = document.getElementById("youtube_background");
	id2 = document.getElementById("www-widgetapi-script");

	if (id1) removeElement("youtube_background");

	if (id2) removeElement("www-widgetapi-script");
}

// END - YOUTUBE API
// ---------------------------

// ---------------------------
// BEGIN - SLIDER

function initHomepageSlider() {
	var swiper = new Swiper('.swiper-container', {
		autoplay: {
		  delay: 5000,
		},
		effect: 'fade',
		parallax: true,
		pagination: {
		  el: '.swiper-pagination',
		  clickable: true,
		  renderBullet: function (index, className) {
			return '<span class="' + className + '"></span>';
		  },
		},
	});
}

function callSlider() {
	if (document.getElementsByClassName("my-slider")[0]) {
		var slider = tns({
			container: ".my-slider",
			items: 1,
			slideBy: "page",
			autoplay: false,
			mode: "carousel",
			autoplayText: false,
			autoplayButton: false,
			autoplayButtonOutput: false,
			controls: true,
			loop: true,
			speed: 900,
			lazyload: true,
			controlsText: ["", ""],
			onInit: sliderCb,
			mouseDrag: true,
			slideBy: "page"
		});
	}

	if (document.getElementsByClassName("my-slider2")[0]) {
		var slider = tns({
			container: ".my-slider2",
			items: 1,
			autoplay: true,
			center: true,
			autoplayText: false,
			autoplayButton: false,
			autoplayButtonOutput: false,
			controls: true,
			loop: true,
			speed: 900,
			lazyload: true,
			controlsText: ["", ""],
			onInit: sliderCb,
			mouseDrag: true,
			slideBy: "page",

			responsive: {
				640: {
					items: 2,
					gutter: 20
				},

				768: {
					items: 3
				}
			}
		});
	}
}

function sliderCb(e) {
	s = e.container;

	var amount = s.dataset.items;
	var totalAmount = amount * 25;
	if (screenWidth < 768) totalAmount = 0;
	var offset = totalAmount + 400;

	label = tr("Grands évènements", "Featured events");

	controls = s.offsetParent.getElementsByClassName("tns-controls");
	controls[0].style.width = offset + "px";
	controls[0].children[0].classList.add("home-evenements__controls-left");
	controls[0].children[0].setAttribute("data-icon", "keyboard_arrow_left");
	controls[0].children[1].classList.add("home-evenements__controls-right");
	controls[0].children[1].setAttribute("data-icon", "keyboard_arrow_right");

	output =
		"" +
		"<div class='home-evenements__controls-label'><span>" +
		label +
		"</span></div>";

	wrapper = document.getElementsByClassName(
		"home-evenements__controls-left"
	)[0];
	wrapper.insertAdjacentHTML("afterend", output);
}

// END - SLIDER
// ---------------------------

function calendarLoad() {
	var calendarEl = document.getElementById("calendar");
	// Create the calendar

	if (calendarEl) {
		CURRENT_CPT = calendarEl.dataset.type;
		var myCalendar = jsCalendar.new({
			target: calendarEl,
			navigator: true,
			navigatorPosition: "both",
			zeroFill: true,
			monthFormat: "month YYYY",
			dayFormat: "D",
			language: theContainer.dataset.lang
		});

		myCalendar.onMonthChange(function(event, date) {
			var dateMonth = jsCalendar.tools.dateToString(date, "MONTH");
			Calendar.prototype.update(dateMonth);
		});

		Calendar.prototype.init();
	}
}

function toggleMobileNav() {
	console.log('toggle');
	var toggleMenu = document.getElementById("toggleBtn");
	var dropdown = document.getElementById("dropdown");
	var scrollContent = document.getElementById("js-scroll-content");

	toggleMenu.addEventListener("click", function() {
		current = toggleMenu.dataset.icon;
		on = "close";
		off = "menu";

		if (current == "menu") {
			toggleMenu.dataset.icon = on;

			if (!scrollContent.classList.contains('nav-active')) {
				scrollContent.classList.add('nav-active');
			}

		} else {
			toggleMenu.dataset.icon = off;

			if (scrollContent.classList.contains('nav-active')) {
				scrollContent.classList.remove('nav-active');
			}
		}
		dropdown.classList.toggle("show");
	});
}

function removeDropdown() {
	document.querySelector("#dropdown").classList.remove("show");
	document.querySelector("#toggleBtn").dataset.icon = "menu";
	scrollContent = document.getElementById("js-scroll-content");

	if (scrollContent.classList.contains('nav-active')) {
		scrollContent.classList.remove('nav-active');
	}
}

function desktopNavHover() {
	var nav = document.querySelector("#menu-main-menu");
	var menu = nav.children;

	for (var i = 1; i < menu.length - 1; i++) {
		var subMenus = menu[i].querySelectorAll(".submenu");

		subMenus.forEach(function(subMenu) {
			menu[i].addEventListener("mouseenter", function() {
				subMenu.classList.add("show");
			});
			menu[i].addEventListener("mouseleave", function() {
				subMenu.classList.remove("show");
			});
			menu[i].addEventListener("click", function() {
				setTimeout(function() {
					subMenu.classList.remove("show");
				}, 150);
			});
		});
	}
}

function mobileHasChildren() {
	var mobileBottomUl = document.querySelector(".header-mobile-dropdown");
	var mobileBottomList = mobileBottomUl.getElementsByClassName(
		"menu-item-has-children"
	);
	for (var i = 0; i < mobileBottomList.length; i++) {
		mobileButton = document.createElement("button");
		mobileButton.className = "mobile-nav-menu-list-item";
		mobileButton.dataset.icon = "arrow_drop_down_circle";
		mobileBottomList[i].insertBefore(
			mobileButton,
			mobileBottomList[i].children[1]
		);
		mobileButton.addEventListener("click", function(e) {
			this.parentNode.children[2].classList.toggle("show");
		});
	}
}

function isActiveLink() {
	var link = window.location.href; // get path of current page

	var navigation = document.getElementsByTagName("ul");

	for (x = 0; x < navigation.length; x++) {
		var navigationLinks = navigation[x].querySelectorAll("li a");
		for (var j = 0; j < navigationLinks.length; j++) {
			var el = navigationLinks[j];

			el.parentNode.classList.remove("selected");
			if (el.href == link) {
				el.parentNode.classList.add("selected");
			}
		}
	}
}

function removeElement(elementId) {
	// Removes an element from the document
	var element = document.getElementById(elementId);
	element.parentNode.removeChild(element);
}

function Sticky() {
	var item;
	items = document.getElementsByClassName("js-sticky");

	if (items.length > 0) {
		StickeyAddHolder();

		StickyHolder = document.getElementById("js-stickyHolder");

		obj = new Object();
		item = items[0];

		// add a unique class to the element
		item.classList.add("sticky-0");
		item.dataset.sticky = "sticky-0";

		// get the element top offset
		rect = item.getBoundingClientRect();
		ot = rect.top;

		// assign values to the object
		obj.element = item;
		obj.ot = ot;

		Stickies.push(obj);

		clone = item.cloneNode(true);
		StickyCopieElement(clone);
	}
}

function StickyCopieElement(clone) {
	clone.classList.add("is-hidden");
	StickyHolder.appendChild(clone);
}

function StickeyAddHolder() {
	out =
		"" +
		'<div class="StickyHolder header container" id="js-stickyHolder">' +
		"</div>";
	theBody.insertAdjacentHTML("afterbegin", out);
}

function StickyWatch() {
	if (Stickies.length > 0) {
		for (var i = 0; i < Stickies.length; i++) {
			s = Stickies[i];

			// get the object html
			element = s.element;

			// get the data-sticky value
			id = element.dataset.sticky;

			stick = StickyHolder.querySelectorAll("[data-sticky='sticky-0']");

			if (!currentlyVisible(element) && !(s.ot > scrolled_y)) {
				stick[0].classList.remove("is-hidden");
			} else {
				stick[0].classList.add("is-hidden");
			}
		}
	}
}

function StickyReset() {
	hasSticky = document.getElementById("js-stickyHolder");
	if (hasSticky) {
		removeElement("js-stickyHolder");
		Stickies = new Array();
		StickyHolder = null;
	}
}

function initLightbox() {
	lightboxItems = document.getElementsByClassName('glightbox');

	if (lightboxItems && lightboxItems.length > 0) {
		lightbox = GLightbox({
			touchNavigation: true,
			loop: true,
			autoplayVideos: true
		});
	} 
}

// **---------------------------------------------------**
// -------------------------------------------------------
// DOMContentLoaded BEGIN
document.addEventListener("DOMContentLoaded", function(e) {
	// console.log("%c" + "---------------------" + "", "color: #D84C4C;");
	// console.log("%c" + "CONTENT LOADED" + "", "color: #D84C4C;");
	// *******************************
	// Functions that get called once on document ready
	checkRedirect();

	loadStyles();
	loadFonts();
	loadScript();

	// scrollbar
	initScrollbar();
	Scrollbar.getAll()[0].addListener(scrolling);

	setTheCurrentLang();

	callSlider();
	calendarLoad();
	initLightbox();
	// watchscroll
	// ScrollItem.prototype.init();
	loadGoogleMap();
	initYoutube();
	mobileHasChildren();

	isActiveLink();

	loadCaptcha();

	setTimeout(function() {
		ScrollItem.prototype.init();
		Accordion.prototype.init();
	}, 2500);

	// Sticky();

	Popup.prototype.setup();

	// desktopNavHover();
	// page first laod animation
	initFirstPageLoad();
});
// DOMContentLoaded END
// -------------------------------------------------------
// **---------------------------------------------------**

window.addEventListener('load', () => {
	initHomepageSlider();
}, false);

// **---------------------------------------------------**
// -------------------------------------------------------
// on resize BEGIN
window.addEventListener(
	"resize",
	function() {
		screenWidth = window.innerWidth;
		screenHeight = window.innerHeight;

		Accordion.prototype.update();
	},
	true
);
// on resize END
// -------------------------------------------------------
// **---------------------------------------------------**

// **---------------------------------------------------**
// -------------------------------------------------------
// on scroll BEGIN
window.addEventListener("scroll", function(e) {
	scrolled_y = window.pageYOffset;

	if (!ticking) {
		window.requestAnimationFrame(function() {
			// place your function(s) here
			ScrollItem.prototype.watch();

			ticking = false;
		});

		ticking = true;
	}
});

/* if you have a custom scrollbar, you need to use this function to get scroll event */
function scrolling() {
	if (scrollbarState) {
		scrolled_y = getCurrentScrollTop();
	}

	if (!ticking) {
		window.requestAnimationFrame(function() {
			onScrollSticky();
			// StickyWatch();
			ticking = false;
		});

		ticking = true;
	}
}

function onScrollSticky() {
	currentScroll = getCurrentScrollTop();

	if (currentScroll < lastKnownScroll) {
		document.querySelector(".header__main-menu").classList.add("sticky");
	} else if (currentScroll > lastKnownScroll) {
		document.querySelector(".header__main-menu").classList.remove("sticky");
	}

	if (currentScroll < 500) {
		document.querySelector(".header__main-menu").classList.remove("sticky");
	}

	lastKnownScroll = currentScroll;
}
// on scroll BEGIN
// **---------------------------------------------------**
// -------------------------------------------------------

function loadCaptcha() {
	var captchaTag = document.createElement("script");
	captchaTag.src = "https://www.google.com/recaptcha/api.js";
	captchaTag.defer = true;
	captchaTag.async = true;
	var firstScriptTag = document.getElementsByTagName("script")[0];
	firstScriptTag.parentNode.insertBefore(captchaTag, firstScriptTag);
}
